import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import About from '../views/about.vue'
import contactUs from '../views/contactUs/contactUs.vue'
import Login from '../views/login/login.vue'
import LoginPhone from '../views/login/login_phone.vue'
import LoginEmail from '../views/login/login_email.vue'
import LoginWechat from '../views/login/wechat.vue'
import LoginAlipay from '../views/login/alipay.vue'
import Confirm from '../views/confirm/confirm.vue'
import Wallet from '../views/wallet/wallet.vue'
import Result from '../views/result/result.vue'
import Order from '../views/order/order.vue'
import OrderDetails from '../views/order/orderDetails.vue'
import Setting from '../views/setting/setting.vue'
import Profile from '../views/setting/profile.vue'
import Settings from '../views/setting/settings.vue'
import Language from '../views/setting/language.vue'
import Coupons from '../views/coupons/coupons.vue'
import Shop from '../views/shop/shop.vue'
import ShopDetails from '../views/shop/shopDetails.vue'
import Help from '../views/help/help.vue'
import WalletIn from '../views/wallet/wallet_in.vue'
import WalletOut from '../views/wallet/wallet_out.vue'
import WalletList from '../views/wallet/wallet_list.vue'
import GoogleMap from '../views/map/google-index.vue'
import DownloadApp from '../views/download/download'
import PaymentCard from '../views/payment/card'
Vue.use(VueRouter)

const routes = [{
  path: '/login',
  name: 'login',
  component: Login,
  meta: {
    ignoreAuth: true
  }
}, {
  path: '/login_phone',
  name: 'login_phone',
  component: LoginPhone,
  meta: {
    ignoreAuth: true
  }
}, {
  path: '/login_email',
  name: 'login_email',
  component: LoginEmail,
  meta: {
    ignoreAuth: true
  }
}, {
  // 默认路径跳转 /map（地图页 google-index.vue；/home 为租借结果页 home.vue，扫码成功后跳转）
  // redirect 用函数形式保留 query，qrcode/zhcode 分享链接从 / 进入不丢参
  path: '/',
  redirect: to => ({ path: '/map', query: to.query, hash: to.hash })
}, {
  path: '/home',
  name: 'home',
  component: Home,
  meta: {
    ignoreAuth: true
  }
}, {
  path: '/login_wechat',
  name: 'login_wechat',
  component: LoginWechat,
  meta: {
    ignoreAuth: true
  }
}, {
  path: '/login_alipay',
  name: 'login_alipay',
  component: LoginAlipay,
  meta: {
    ignoreAuth: true
  }
}, {
  path: '/about',
  name: 'about',
  component: About
}, {
  path: '/confirm',
  name: 'confirm',
  component: Confirm
}, {
  path: '/wallet',
  name: 'wallet',
  component: Wallet
}, {
  path: '/result',
  name: 'result',
  component: Result
}, {
  path: '/order',
  name: 'order',
  component: Order
}, {
  path: '/order/:orderId',
  name: 'order_details',
  component: OrderDetails
}, {
  path: '/setting',
  name: 'setting',
  component: Setting,
  meta: {
    ignoreAuth: true
  }
}, {
  path: '/settings',
  name: 'settings',
  component: Settings
}, {
  path: '/profile',
  name: 'profile',
  component: Profile
}, {
  path: '/settings/language',
  name: 'settings_language',
  component: Language
}, {
  path: '/coupons',
  name: 'coupons',
  component: Coupons
}, {
  path: '/shop',
  name: 'shop',
  component: Shop
}, {
  path: '/shop/details/*',
  name: 'shopDetails',
  component: ShopDetails
}, {
  path: '/help',
  name: 'help',
  component: Help
}, {
  path: '/wallet_in',
  name: 'wallet_in',
  component: WalletIn
}, {
  path: '/wallet_out',
  name: 'wallet_out',
  component: WalletOut
}, {
  path: '/wallet_list',
  name: 'wallet_list',
  component: WalletList
}, {
  path: '/google_map',
  name: 'google_map',
  component: GoogleMap,
  alias: '/map'
}, {
  path: '/payment_card',
  name: 'payment_card',
  component: PaymentCard
}, {
  path: '/download',
  name: 'download',
  component: DownloadApp
},
{
  path: '/contactUs',
  name: 'contactUs',
  component: contactUs,
  meta: { ignoreAuth: true }
}]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_DOMAIN,
  routes
})

router.beforeEach((to, from, next) => {
  console.log('to', to)
  // /home 无 cabinetshow=true 时，重定向到 /map，用户只能看到租借详情页
  if (to.name === 'home' && to.query.cabinetshow !== 'true') {
    next({ path: '/map', query: to.query })
    return
  }
  const token = store.state.token
  // 首页为 /map（google_map），qrcode/zhcode 分享链接从 / 进入时同样需要入 store
  if (to.name === 'home' || to.name === 'google_map') {
    if (to.query.qrcode) {
      store.commit('qrcode', to.query.qrcode)
      store.commit('zhcode', '')
    }
    if (to.query.zhcode) {
      store.commit('zhcode', to.query.zhcode)
      store.commit('qrcode', '')
    }
  }
  if (to.matched.some(r => r.meta.ignoreAuth) || token) {
    next()
  } else {
    next({
      path: '/login'
    })
  }
})

export default router
